module.exports = __webpack_public_path__ + "fonts/Nexa_Light.989d70a3.woff2";